import script from "./WelcomePage.vue?vue&type=script&setup=true&lang=js"
export * from "./WelcomePage.vue?vue&type=script&setup=true&lang=js"

import "./WelcomePage.vue?vue&type=style&index=0&id=01b94ae7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01b94ae7"]])

export default __exports__